module.exports = __webpack_public_path__ + "img/select-lang-btn-ar.3630e973.png";